const greyMap = [
  {
      "elementType": "geometry",
      "stylers": [{ "color": "#f5f5f5" }]
  },
  {
      "elementType": "labels.icon",
      "stylers": [{ "visibility": "off" }]
  },
  {
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#616161" }]
  },
  {
      "elementType": "labels.text.stroke",
      "stylers": [{ "color": "#f5f5f5" }]
  },
  {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#bdbdbd" }]
  },
  {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{ "color": "#eeeeee" }]
  },
  {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#757575" }]
  },
  {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{ "color": "#e5e5e5" }]
  },
  {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#9e9e9e" }]
  },
  {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{ "color": "#ffffff" }]
  },
  {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#757575" }]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [{ "color": "#dadada" }]
  },
  {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#616161" }]
  },
  {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#9e9e9e" }]
  },
  {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [{ "color": "#e5e5e5" }]
  },
  {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [{ "color": "#eeeeee" }]
  },
  {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{ "color": "#D0E3EF" }]
  },
  {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#D0E3EF" }]
  }
];

class ServicePoints extends HTMLElement {
    constructor() {
        super();
        this.mapElement = this.querySelector("#map");
        this.input = this.querySelector('#pac-input');
        this.svg = this.querySelector('svg').outerHTML;
        this.getLocations();
    }

    connectedCallback() {
        this.initMap().then(() => {
            this.afterInitTasks();
        });
    }

    getLocations() {
        this.locations = this.locations || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.locations;
    }

    async initMap() {
        // Request needed libraries.
        const { Map, InfoWindow } = await google.maps.importLibrary("maps");
        await google.maps.importLibrary("places");  // Importing the places library
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

        this.mapInstance = new Map(this.mapElement, {
            zoom: 7,
            styles: greyMap,
            center: { lat: 52.122290, lng: 5.046390 },
            mapId: "9fb0e7be2cfcd391",
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_LEFT,
            }
        });

        const services = this.getLocations();

        const infoWindow = new InfoWindow();
        this.markers = [];

        services.forEach(({ position, title, address, premium }, i) => {
            const parser = new DOMParser();
            const pinSvg = parser.parseFromString(
                this.svg,
                "image/svg+xml",
            ).documentElement;
            
            title = `<span class='search-result__title'>${title}</span>`;
            
            const marker = new AdvancedMarkerElement({
                position,
                map: this.mapInstance,
                title: title,
                content: pinSvg,
            });

            marker.addListener("click", (event) => {
                console.log(position);

                infoWindow.close();
                infoWindow.setContent(`${title}  <span class='search-result__address'>${address}</span><a class="directions" href="https://www.google.com/maps/dir/?api=1&destination=${position.lat},${position.lng}" target="_blank">${window.mapStrings.route}</a>
                `);
                infoWindow.open(marker.map, marker);
                this.mapInstance.setZoom(10);
                this.mapInstance.setCenter(marker.position);
            });

            this.markers.push(marker);
        });
        const parser = new DOMParser();
        const pinSvg = window.btoa(parser.parseFromString(this.svg, "image/svg+xml").documentElement.outerHTML);

        var renderer = {
            render: ({ count, position }) => {
                console.log(renderer);
            var mark = new google.maps.Marker({
                label: { className: 'map-cluster', text: String(count)
            },
                icon: {
                    url: `data:image/svg+xml;base64,${pinSvg}`,
                    scaledSize: new google.maps.Size(45, 45),
                  },
                position: position,
                map: this.map,
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            });
          
              return mark;
            }
        };
        
        new markerClusterer.MarkerClusterer({
            markers: this.markers,
            map: this.mapInstance,
            renderer
        });


    }


    afterInitTasks() {
        this.searchResults = this.querySelector('search-results');
        this.searchResults.init();
    }
}

customElements.define('service-points', ServicePoints);

class SearchResults extends HTMLElement {
    constructor() {
        super();
        this.init();
        this.searchInput = this.querySelector('input[type="search"]');
        this.searchInput.addEventListener('input', this.filterResults.bind(this));
    }

    init() {
        this.servicePoints = this.closest('service-points');
        this.results = this.querySelectorAll('button');
        this.results.forEach(result => {
            result.addEventListener('click', this.onResultClick.bind(this));
        });
    }

    onResultClick(e) {
        e.preventDefault();
        const markers = this.servicePoints.getLocations();
        google.maps.event.trigger(this.servicePoints.markers[e.target.dataset.marker], 'click');
        // this.hideAllResults();
    }

    showResult(result) {
        result.style.display = '';
    }

    hideResult(result) {
        result.style.display = 'none';
    }

    hideAllResults() {
        this.searchInput.value = '';
        this.querySelectorAll('li').forEach(li => this.hideResult(li));
        this.classList.add('hide-all-results');
    }

    filterResults() {
        const query = this.searchInput.value.toLowerCase();
        this.classList.remove('hide-all-results');
        this.querySelectorAll('li.search-result').forEach(li => {
            const location = li.querySelector('.search-result__link').textContent.toLowerCase();
        
            if (location.includes(query)) {
                this.showResult(li);
            } else {
                this.hideResult(li);
            }
        });

        // show "no results" 
        if (!this.querySelectorAll('li.search-result:not([style*="display: none"])').length) {
            this.querySelector('.no-results').style.display = '';
        } else {
            this.querySelector('.no-results').style.display = 'none';
        }
    }
}
 
customElements.define('search-results', SearchResults);